export default __webpack_public_path__ + "static/media/AcceptIcon.f85e81a8.svg";